import React from 'react'

export default class Image extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
    this.setup=this.setup.bind(this)
    this.setSrc=this.setSrc.bind(this)
  }
  componentDidMount() {
    this.init(this.props)
    window.addEventListener('resize', this.setup)
    window.addEventListener('scroll', this.setSrc)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.setup)
    window.removeEventListener('scroll', this.setSrc)
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps !== this.props) {
      this.init(nextProps)
    }
    return true
  }
  init(props) {
    this.setImage(props,()=>{
      this.setup(this.props)
    })
  }
  setup(props) {
    if (typeof(props)==='object'&&props!==null) {
      if (typeof(this.container)==='object') {
        let width = this.container.offsetWidth
        if (typeof(width)==='number'&&width>0) {
          const aspectRatio = this.state.aspectRatio
          if (typeof(aspectRatio)==='number') {
            const height = width/aspectRatio
            this.setState({
              width:width,
              height:height,
            }, ()=>{
              this.setSrc()
            })
          } else {
            this.setState({width:width}, ()=>{
              this.setSrc()
            })
          }
        } else {
          this.setSrc()
        }
      }
    }
  }
  setImage(props,cb) {
    if (typeof(props)==='object'&&props!==null) {
      let image = props
      if (typeof(image[0])==='object'&&image[0]!==null) {
        image = image[0]
      }
      if (typeof(image)==='object'&&image!==null) {
        this.setState({image:image},()=>{
          const aspectRatio = image.aspectRatio
          if (typeof(aspectRatio)==='number') {
            this.setState({aspectRatio:aspectRatio},()=>{
              if (typeof(cb)==='function') {
                cb()
              }
            })
          } else {
            if (typeof(cb)==='function') {
              cb()
            }
          }
        })
      }
    }
  }
  setSrc(cb) {
    if (
      (this.state.src===undefined||
        (
          typeof(this.state.src)==='string'&&
          this.state.src.length===0
        )
      )&&
      this.isInViewport!==true
    ) {
      this.setState({src:''},()=>{
        if (typeof(cb)==='function') {
          cb()
        }
      })
      return
    }
    const image = this.state.image
    if (typeof(image)==='object'&&image!==null) {
      const fileName = image.name
      if (typeof(fileName)==='string'&&fileName.length>0) {
        const width = this.props.maxWidth||this.state.width
        const sizes = image.sizes
        if (typeof(width)==='number'&&width>0 && Array.isArray(sizes)&&sizes.length>0) {
          let i=0
          while(i<sizes.length) {
            if (sizes[i].width>=width) break
            i++
          }
          if (i<sizes.length) {
            let size = sizes[i]
            if (typeof(size)==='object'&&size!==null) {
              // calculate how much different, if >50% use it or use i-1
              if (i>0) {
                const sizeWidth = sizes[i-1].width
                if (typeof(sizeWidth)==='number'&&sizeWidth>0) {
                  if ((width-sizeWidth)/sizeWidth<=.5) {
                    size = sizes[i-1]
                  }
                }
              }
              const dataPath = `/data`
              const imagesPath = `${dataPath}/images/w${size.width}`
              const src = `${imagesPath}/${fileName}`
              this.setState({src:src}, ()=>{
                if (typeof(cb)==='function') {
                  cb()
                }
              })
            }
          } else {
            const dataPath = `/data`
            const imagesPath = `${dataPath}/images/_`
            const src = `${imagesPath}/${fileName}`
            this.setState({src:src}, ()=>{
              if (typeof(cb)==='function') {
                cb()
              }
            })
          }
        } else {
          if (Array.isArray(sizes)&&sizes.length>0) {
            const maxWidth = this.props.maxWidth
            if (typeof(maxWidth)==='number'&&maxWidth>0) {
              this.setState({width:maxWidth},()=>{
                this.setSrc(cb)
              })
            }
          } else {
            const dataPath = `/data`
            const imagesPath = `${dataPath}/images/_`
            const src = `${imagesPath}/${fileName}`
            this.setState({src:src}, ()=>{
              if (typeof(cb)==='function') {
                cb()
              }
            })
          }
        }
      }
    }
  }
  /**
   * Check if the component is in the viewport
   * @return {Boolean} If the component is in viewport
   */
  get isInViewport(): boolean {
    // get element position in viewport
    const rect: RectType = this.container.getBoundingClientRect()
    // get viewport height and width
    const viewportHeight: number = (window.innerHeight || document.documentElement.clientHeight)
    const viewportWidth: number = (window.innerWidth || document.documentElement.clientWidth)
    // check if the element is in the viewport (or near to them)
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top < viewportHeight &&
      rect.left < viewportWidth
    )
  }
  imageStyle() {
    if (this.props.viewMode==='full') {
      const width = this.state.width
      const height = this.state.height
      if (typeof(width)==='number'&&typeof(height)==='number') {
        return {
          width: `${width}px`,
          height: `${height}px`,
        }
      }
    }
    return {}
  }
  render() {
    return (
      <div ref={el=>{this.container=el}} className={this.props.className}>
        {
          typeof(this.state.src)==='string'&&
          this.state.src.length>0&&
          <img
            className={this.props.imgClassName}
            src={this.state.src}
            alt=""
            style={this.imageStyle()}
          />
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Image.js